import { Injectable } from '@angular/core';
import {Subject ,Observable} from 'rxjs' ;
@Injectable({
  providedIn: 'root'
})
export class TranslateServiceService {
lang:Observable<any> ;
private changeLangSubject = new Subject<any>()

  constructor() {
    // console.log(this.changeLangSubject)
    this.lang = this.changeLangSubject.asObservable();
   }
   public langData(data) {
     this.lang = data;
     this.lang = this.changeLangSubject.asObservable();
   
     this.changeLangSubject.next(data)
   }
}